import type { Action } from "@reduxjs/toolkit";
export type InstanceAction = Action<"Instance"> & {
    payload: number
}

export const InstanceReducer = (state: number = 0, action: InstanceAction) => (action.type === "Instance" ? action.payload : state)
